import MapBox from './../modules/map'
import { EventDetailsPanel } from '../components/EventDetailsPanel/EventDetailsPanel'
import * as turf from '@turf/turf'

export class HotspotsModule {
  hotspots = []
  showHotspot = false

  constructor() { }

  initialize(hotspots) {
    this.hotspots = hotspots
    this.display()
    this.initializeEventListeners()
  }

  getFeatureCollection(hotspots) {
    var featureCollection = {
      type: 'FeatureCollection',
      features: []
    }

    for (var hotspot of hotspots) {

      var features = turf.points(hotspot.geo.coordinates[0])
      var center = turf.center(features)

      var properties = {
        ['id']: hotspot.id,
        ['time']: hotspot.updated,
        ['headline']: hotspot.name,
        ['location']: hotspot.region.name,
        ['summary']: hotspot.headline,
        ['threatLevel']: hotspot.threatLevel.description,
        ['type']: hotspot.type.description,
        ['latlng']: center.geometry.coordinates
      }

      var feature = {
        type: 'Feature',
        id: hotspot.id,
        geometry: {
          'type': 'Polygon',
          'coordinates': hotspot.geo.coordinates
        },
        properties
      }

      featureCollection.features.push(feature)
    }

    return featureCollection
  }

  display() {
    const portsFeatureCollection = this.getFeatureCollection(this.hotspots)

    const hotspotsLayers = MapBox.map.getSource('hotspots')
    if (hotspotsLayers !== undefined) {
      hotspotsLayers.setData(portsFeatureCollection)
    } else {

      MapBox.map.addSource('hotspots', {
        'type': 'geojson',
        'data': portsFeatureCollection
      })

      MapBox.map.addLayer({
        'id': 'hotspots',
        'type': 'fill',
        'source': 'hotspots',
        'layout': {
          'visibility': this.showHotspot ? 'visible' : 'none',
        },
        'paint': {
          'fill-color': 'rgba(218, 50, 90, 0.5)',
          'fill-opacity': 0.5
        }
      })

      MapBox.map.addLayer({
        'id': 'hotspots-outline',
        'type': 'line',
        'source': 'hotspots',
        'layout': {
          'visibility': this.showHotspot ? 'visible' : 'none',
        },
        'paint': {
          'line-color': '#DA325A',
          'line-width': 1
        }
      })

      MapBox.map.addLayer({
        'id': 'hotspots-outline-highlighted',
        'type': 'line',
        'source': 'hotspots',
        'layout': {
          'visibility': 'none',
        },
        'paint': {
          'line-color': '#3CDEC1',
          'line-width': 3
        }
      })
    }
  }

  highlightHotspot(hotspotId) {
    MapBox.map.setFilter('hotspots-outline-highlighted', ['==', 'id', hotspotId])
    MapBox.map.setLayoutProperty('hotspots-outline-highlighted', 'visibility', 'visible')
  }

  show() {
    this.showHotspot = true
    MapBox.map.setLayoutProperty('hotspots', 'visibility', 'visible')
    MapBox.map.setLayoutProperty('hotspots-outline', 'visibility', 'visible')
  }

  hide() {
    this.showHotspot = false
    MapBox.map.setLayoutProperty('hotspots', 'visibility', 'none')
    MapBox.map.setLayoutProperty('hotspots-outline', 'visibility', 'none')
  }

  initializeEventListeners() {
    MapBox.map.on('mouseenter', 'hotspots', (e) => {
      MapBox.map.getCanvas().style.cursor = 'pointer'
    })
  }
}

const Hotspots = new HotspotsModule()
export default Hotspots